const o = "1.18.1";
export {
  o as VERSION
};
